


















import Vue from 'vue';

export default Vue.extend({
	name: '',

	props: {
		tab: Number,
	},

	data: () => ({}),

	methods: {
		changeTab(tabIndex: number) {
			this.$emit('tabChanged', tabIndex);
		},
	},
});
